import styles from './style.module.scss';
import activeIcon from '../../assets/svg/time-line-active-moblie.svg';
import defaultIcon from '../../assets/svg/time-line-default.svg';
import classNames from 'classnames';

interface IProps {
  readonly selectTimeKey: string;
  readonly setSelectTimeKey: (value: string) => void;
  readonly classifyList: string[];
  readonly setActiveItem: (value: number) => void;
  readonly isFixed: boolean;
}

export const RoadmapTimeLineMobile = (props: IProps) => {
  return (
    <div className={classNames(styles.roadmapTimeLineMobileBox, props.isFixed ? styles.colorStyle : '')} id="roadmapTimeLineMobileBox">
      <div className={styles.timeLine}>
        {props.classifyList.map((item, index) => {
          if (index > 2) {
            return null;
          }
          return (
            <div
              className={
                props.selectTimeKey === item ? styles.activeTimeLine : ''
              }
            >
              <div
                className={classNames(
                  styles.timeLineDefault,
                  styles[`timeLine${index}`]
                )}
                onClick={() => {
                    props.setSelectTimeKey(item)
                    props.setActiveItem(0);
                }}
              >
                <span>{item}</span>
                <img
                  src={props.selectTimeKey === item ? activeIcon : defaultIcon}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
